<template>
  <div class="ma-6">
    <div class="page-header-left">
      <h2 class="pr-3">Pencarian</h2>
    </div>
    <div class="mt-4 pr-0 pl-0 pt-2" style="border: thin solid rgba(0,0,0,.12)">
      <v-tabs  v-model="tab">
        <v-tab><v-badge color="green" :content="productpricingcari.length">Produk</v-badge></v-tab>
        <v-tab><v-badge color="green" :content="suppliercari.length">Penjual</v-badge></v-tab>
        <v-tab-item>
          <CariProduk/>
        </v-tab-item>
        <v-tab-item>
          <CariSuplier/>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import CariProduk from '@/components/CariProduk'
import CariSuplier from '@/components/CariSuplier'
import { mapState } from 'vuex'
export default {
  name: 'CariSuplierdanProduk',
  components: { CariSuplier, CariProduk },
  data: () => ({
    tab: null
  }),
  computed: {
    ...mapState('ProductStore', ['suppliercari', 'productpricingcari']),
    cari () {
      return this.$route.query
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
